import { useMemo } from "react"
import { GetStudyLibraryDocument, type LibrarySortType } from "~/graphql/generated/graphql"
import { reportGaps } from "~/shared/lib/schemas"
import { logLibraryEdges } from "../cardTelemetry"
import { isStudyEdge } from "../guards"
import { toStudyCard } from "../projections"
import type { LibraryCardItem } from "../types"
import { useLibraryQuery } from "./useLibraryQuery"

export interface LibraryListResult {
  readonly items: readonly LibraryCardItem[]
  readonly isLoading: boolean
  readonly isError: boolean
  readonly hasNextPage: boolean
  readonly isFetchingNextPage: boolean
  readonly fetchNextPage: () => void
}

export const useStudyLibrary = (sortBy: LibrarySortType): LibraryListResult => {
  const query = useLibraryQuery("study", GetStudyLibraryDocument, sortBy)
  const items = useMemo(() => {
    const edges = (query.data?.pages ?? []).flatMap(page => page.user?.libraryV2?.edges ?? []).filter(isStudyEdge)

    logLibraryEdges("studies", edges)

    const cards = edges.map(edge => toStudyCard(edge.node.asset))

    reportGaps("studies", cards)

    return cards
  }, [query.data?.pages])

  return {
    items,
    isLoading: query.isLoading,
    isError: query.isError,
    hasNextPage: query.hasNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
  }
}
